import { Component, OnInit } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { DialogService, DynamicDialogComponent, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ModalService } from 'src/app/shared/services/modal.service';
import { AgendaModalComponent } from '../agenda-modal/agenda-modal.component';

@Component({
  selector: 'app-available-schedule-modal',
  templateUrl: './available-schedule-modal.component.html',
  styleUrls: ['./available-schedule-modal.component.scss']
})
export class AvailableScheduleModalComponent implements OnInit {
  profissionais !: TreeNode[];
  exames !: TreeNode[];

  constructor(public config: DynamicDialogComponent, public dialogService: DialogService) {}

 
  openModalAgenda() {
    this.dialogService.open(AgendaModalComponent, {
      width: '70%',
      height: '100%',
      style: {
        'height': '97vh',
        'max-height': '98vh',
        //'padding' : '0 1.5rem 0.9rem 1.5rem'
      },
      // contentStyle: { 'border-radius': '6px' },
      baseZIndex: 10000,
      dismissableMask: true,
      styleClass: 'dialogComponent dialog-header-disabled' ,
      data: []
    });
  }
  
  closeModal() {
    this.config.close()
  }

  ngOnInit(): void {
    this.profissionais = this.getProfissionais();
    this.exames = this.getExames();
  }
  getExames() {
    return [
      {
          key: '0',
          label: 'Exames',
          icon: 'pi',
          children: [{}]
      }
    ]
  }
  getProfissionais() {
    return [
        {
            key: '0',
            label: 'Profissionais',
            children: [
                {
                    key: '0-0',
                    label: 'Dr. Anderson Costa',
                    data: '1'
                },
                {
                    key: '0-1',
                    label: 'Dr. Carlos lopes',
                    data: '2'
                },
                {
                    key: '0-2',
                    label: 'Dra. Gabriela santos',
                    data: '2'
                },
                {
                    key: '0-3',
                    label: 'Dr. Henrique Augusto',
                    data: '3'
                },
                {
                    key: '0-4',
                    label: 'Dra. Maria Fernanda',
                    data: '4'
                }
            ]
        }
    ];
}
}
